module.exports = __webpack_public_path__ + "co.svg?884797ba3ba63eccdf9348b6d6892950";